import { useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import { AssetModal } from '../components/AssetModal'
import { UploadAssetModal } from '../components/UploadAssetModal'
import { CampaignAPI } from '../api/CampaignAPI'

const EVENT_DISPLAY_MAP = {
    blog: {
        title: 'Blog Post',
        color: 'red',
    },
    custom: {
        title: 'Custom Upload',
        color: 'blue',
    },
    listing: {
        title: 'Listing',
        color: 'purple',
    },
    quotes: {
        title: 'Quote Post',
        color: 'green',
    },
    video_submission: {
        title: 'Video Clip',
        color: 'orange',
    },
}

export const CalendarPage = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [isCreateOpen, setIsCreateOpen] = useState(false)
    const [modalAsset, setModalAsset] = useState(null)

    const handleAssetClick = (e) => {
        let asset = e.event.extendedProps.extras
        setModalAsset(asset)
        setIsOpen(true)
    }

    const handleModalClose = () => {
        setIsOpen(false)
    }

    const refreshPage = () => {
        // TODO: This is a quick way to get V1 working. In the future, consider mutating the existing table
        // client-side to represent the actions taken in the modal for better performance.
        window.location.reload()
    }

    const fetchEvents = (fetchInfo, onSuccess, onFailure) => {
        return CampaignAPI.getScheduledAssets(
            fetchInfo.startStr,
            fetchInfo.endStr
        )
            .then((result) => {
                let parsed = result.data.map((asset) => {
                    let displayProps = EVENT_DISPLAY_MAP[asset.type]
                    return {
                        title: displayProps.title,
                        start: asset.schedule_date,
                        color: displayProps.color,
                        extras: {
                            id: asset.id,
                            campaign_id: asset.campaign_id,
                            source_url: asset.source_url,
                            caption: asset.caption,
                            schedule_date: asset.schedule_date,
                            target_network: asset.network_type,
                            publish_to: asset.publish_to,
                        },
                    }
                })
                onSuccess(parsed)
            })
            .catch(onFailure)
    }

    return (
        <>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                customButtons={{
                    test: {
                        text: 'Create Post',
                        click: () => {
                            setIsCreateOpen(true)
                        },
                    },
                }}
                headerToolbar={{
                    left: 'title',
                    center: null,
                    right: 'prev,next today test',
                }}
                events={fetchEvents}
                eventClick={handleAssetClick}
                eventDisplay="block"
            />
            {modalAsset && (
                <AssetModal
                    isOpen={isOpen}
                    campaignId={modalAsset.campaign_id}
                    asset={modalAsset}
                    onClose={handleModalClose}
                    onAssetChanged={refreshPage}
                />
            )}
            <UploadAssetModal
                isOpen={isCreateOpen}
                onClose={() => setIsCreateOpen(false)}
                onAssetsCreated={refreshPage}
            />
        </>
    )
}
